import React, { useState } from "react";
import { Button } from "react-bootstrap";
import AllAdmins from "./AllAdmins";
import Roles_Permissions from "./Roles_Permissions";
import CreateAdmin from "./CreateAdmin";
import CreateRole from "./CreateRole";
import adminsViewIcon from "../../assets/icons/admin_view.svg";
import rolesViewIcon from "../../assets/icons/roles_view.svg";
import backBtn from "../../assets/icons/arrow_left.svg";
import "../../styles/admin-mgt.css";

const AdminManagement = () => {
	const [activeTab, setActiveTab] = useState('admins');
	const [showInviteAdmin, setShowInviteAdmin] = useState(false);
	const [showCreateRole, setShowCreateRole] = useState(false);
	const [pageTitle, setPageTitle] = useState("Admin Management");

	const handleTabClick = (tab: React.SetStateAction<string>) => {
		setActiveTab(tab);
		setShowInviteAdmin(false);
		setShowCreateRole(false);
		setPageTitle("Admin Management");
	};

	const handleInviteAdmin = () => {
		setShowInviteAdmin(true);
		setShowCreateRole(false);
		setPageTitle("Invite New Admin");
	};

	const handleCreateRole = () => {
		setShowCreateRole(true);
		setShowInviteAdmin(false);
		setPageTitle("Create New Role");
	};

	const handleBackClick = () => {
		setShowInviteAdmin(false);
		setShowCreateRole(false);
		setPageTitle("Admin Management");
	};

	return (
		<>
			<div className="component-body">
				<div className="page-title">
					<div style={{ display: 'flex', gap: '20ps' }} className="custom-back">
						{(showInviteAdmin || showCreateRole) && (
							<img src={backBtn} alt="back" style={{ cursor: 'pointer' }} onClick={handleBackClick} />
						)}
						<h4>{pageTitle}</h4>
					</div>

					{!showInviteAdmin && !showCreateRole && activeTab === 'admins' && (
						<Button className="create-new py-2" onClick={handleInviteAdmin}>Invite Admin</Button>
					)}
					{!showInviteAdmin && !showCreateRole && activeTab === 'roles' && (
						<Button className="create-new py-2" onClick={handleCreateRole}>Create Role</Button>
					)}
				</div>

				{!showInviteAdmin && !showCreateRole && (
					<div className="table-tabs my-2">
						<div
							className={`admins-view category ${activeTab === 'admins' ? 'category-active' : ''}`}
							onClick={() => handleTabClick('admins')}
						>
							<img src={adminsViewIcon} alt="admins" />
							<span>Administrators</span>
						</div>

						<div
							className={`admins-view category ${activeTab === 'roles' ? 'category-active' : ''}`}
							onClick={() => handleTabClick('roles')}
						>
							<img src={rolesViewIcon} alt="roles" />
							<span>Roles and Permissions</span>
						</div>
					</div>
				)}
				<div>
					{!showInviteAdmin && !showCreateRole && activeTab === 'admins' && <AllAdmins />}
					{!showInviteAdmin && !showCreateRole && activeTab === 'roles' && <Roles_Permissions />}
					{showInviteAdmin && <CreateAdmin />}
					{showCreateRole && <CreateRole />}
				</div>
			</div>
		</>
	);
};

export default AdminManagement;
